import { render, staticRenderFns } from "./LawyerAccidentForm.vue?vue&type=template&id=1575f658&scoped=true&"
import script from "./LawyerAccidentForm.vue?vue&type=script&lang=js&"
export * from "./LawyerAccidentForm.vue?vue&type=script&lang=js&"
import style0 from "./LawyerAccidentForm.vue?vue&type=style&index=0&id=1575f658&scoped=true&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575f658",
  null
  
)

export default component.exports